import { generateClient } from 'aws-amplify/api';
import { getCurrentUser } from 'aws-amplify/auth';
import * as mutations from '../graphql/mutations';
import * as queries from '../graphql/queries';

const client = generateClient();

export const getPathfinderNeuroSurgDomainKeyByIndex = (index) => {
  const domainKeys = [
    "Undergraduate Career (research, audit, QI, prizes/awards)",
    "Undergraduate clinical electives and attachments",
    "Higher Degree (full-time original research e.g. PhD/MD/Masters by research; excluding degrees integral to curriculum)",
    "First Degree in Medical Sciences (e.g. BSc/BMedSci/MRes; excluding intercalated degrees as part of medical course)",
    "Other Degrees and Diplomas",
    "Postgraduate Research",
    "Postgraduate Academic Awards and Prizes",
    "Postgraduate Clinical Courses (including neurosurgery-relevant and surgical skills courses)",
    "Publications (accepted for publication as a minimum standard)",
    "Presentations",
    "Clinical Audit and Quality Improvement Projects",
    "Organisational and Leadership Skills (including management experience and understanding of NHS management/resources)",
    "Operative Experience (including validated logbook documentation of surgical exposure)",
    "Teaching (including experience of teaching and communication to a range of audiences)",
    "Personal Statement 1 (demonstrating insight, commitment, understanding of programme, and NHS values)",
    "Surgical Placement Experience in Neurosurgery and Allied Specialties"
  ];
  
  const numericIndex = Number(index);
  if (isNaN(numericIndex)) {
    return `Unknown domain ${index}`;
  }
  
  return domainKeys[numericIndex] || `Unknown domain ${index}`;
};

const isNumericDomainKey = (key) => {
  return !isNaN(Number(key)) && key !== null && key !== '';
};

export const savePathfinderNeuroSurgDomainScore = async (domainKey, points) => {
  try {
    const textDomainKey = isNumericDomainKey(domainKey) 
      ? getPathfinderNeuroSurgDomainKeyByIndex(Number(domainKey))
      : domainKey;
    
    const user = await getCurrentUser();
    if (!user) throw new Error('User not authenticated');

    console.log(`Saving PathfinderNeuroSurgDomainScore: domainKey="${textDomainKey}", points=${points}`);

    const { data } = await client.graphql({
      query: queries.listPathfinderNeuroSurgDomainScores,
      variables: {
        filter: { 
          userId: { eq: user.username }, 
          domainKey: { eq: textDomainKey }
        }
      },
      authMode: 'userPool'
    });

    const existingRecord = data.listPathfinderNeuroSurgDomainScores.items[0];

    if (existingRecord) {
      const input = {
        id: existingRecord.id,
        userId: user.username,
        domainKey: textDomainKey,
        progress: points,
        owner: user.username,
        _version: existingRecord._version
      };

      console.log('Updating existing NeuroSurg record with input:', input);
      const result = await client.graphql({
        query: mutations.updatePathfinderNeuroSurgDomainScore,
        variables: { input },
        authMode: 'userPool'
      });
      
      return result;
    } else {
      const input = {
        userId: user.username,
        domainKey: textDomainKey,
        progress: points,
        owner: user.username
      };

      console.log('Creating new NeuroSurg record with input:', input);
      const result = await client.graphql({
        query: mutations.createPathfinderNeuroSurgDomainScore,
        variables: { input },
        authMode: 'userPool'
      });
      
      return result;
    }
  } catch (error) {
    console.error('Error saving Pathfinder NeuroSurg domain score:', error);
    throw error;
  }
};

export const fetchAllPathfinderNeuroSurgDomainScores = async () => {
  try {
    const user = await getCurrentUser();
    if (!user) throw new Error('User not authenticated');

    const { data } = await client.graphql({
      query: queries.listPathfinderNeuroSurgDomainScores,
      variables: {
        filter: { userId: { eq: user.username } },
        limit: 100
      },
      authMode: 'userPool'
    });

    return data.listPathfinderNeuroSurgDomainScores.items;
  } catch (error) {
    console.error('Error fetching Pathfinder NeuroSurg domain scores:', error);
    return [];
  }
};